import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Box, Typography } from '@mui/material';
import '@aws-amplify/ui-react/styles.css';
import './override-amplify.css';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

// Custom styles to override Amplify UI defaults
const authStyles = {
  container: {
    backgroundColor: '#121212',
    color: 'white',
  },
  header: {
    textAlign: 'center',
    padding: '2rem',
    background: 'linear-gradient(45deg, #1a1a1a 30%, #333333 90%)',
    borderRadius: '0 0 10px 10px',
    marginBottom: '2rem',
  },
  footer: {
    textAlign: 'center',
    padding: '1rem',
    color: '#999',
  }
};

const CustomAuthenticator = ({ children }) => {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Authenticator
        hideSignUp={true}
        components={{
          Header() {
            return (
              <Box sx={authStyles.header}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'white' }}>
                  Movie Player
                </Typography>
                <Typography variant="subtitle1" sx={{ color: '#cccccc' }}>
                  Admin Login
                </Typography>
              </Box>
            );
          },
          Footer() {
            return (
              <Box sx={authStyles.footer}>
                <Typography variant="body2">
                  Movie Player Admin Panel
                </Typography>
              </Box>
            );
          }
        }}
      >
        {children}
      </Authenticator>
    </ThemeProvider>
  );
};

export default CustomAuthenticator;